// extracted by mini-css-extract-plugin
export var services = "services-module--services--1IuAM";
export var serviceCards = "services-module--serviceCards--188KK";
export var serviceCard = "services-module--serviceCard--ENa1V";
export var tools = "services-module--tools--q4N5Z";
export var devTools = "services-module--devTools--3Q483";
export var devTool = "services-module--devTool--38pJ4";
export var Express = "services-module--Express--1z6Ma";
export var Next = "services-module--Next--1_Sq_";